<template>
  <div class="page-container">    
     <!-- 使用 TheHeader 组件 -->
    <the-header></the-header>
    <div class="page-main">
      <div class="page-sidebar">
        <!-- Sidebar -->
        <van-sidebar v-model="activeKey">
          <van-sidebar-item v-for="item in sidebarItems" :key="item.name" :title="item.title" :to="item.to" />
        </van-sidebar>
      </div>
      <div class="page-content">
        <!-- Content -->
        <div class="content-list">
          <el-card v-for="data in datas" :key="data.id" class="content-item" :style="{ width: '100%' }" :body-style="{ padding: '20px' }">
            <div class="title-and-status">
              <span class="title">{{ data.title }}</span>
              <el-tag  v-if="data.is_closed === 1">已结单</el-tag>
              <el-tag  v-else>考评中</el-tag>
   
            </div>
            <div class="time">
              <p><strong>发布时间：</strong>{{ data.released_at }}</p>
              <p><strong>结单时间：</strong>{{ data.close_at }}</p>              
            </div>
            <hr>
            <div class="description">
              <p>{{ data.description }}              
                <el-button v-if="data.is_closed === 1" type="warning"  class="right-button">已结单</el-button>
                <el-button v-else type="primary"  class="right-button" @click="goToAssess(data.id)">去考评</el-button>
              </p>
              
            </div>
          </el-card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import TheHeader from './TheHeader.vue'; // 导入 TheHeader 组件
import { onMounted } from 'vue';
import useUserStore from '@/stores/user';
import api from '@/api';

export default {
  components: {
    TheHeader, // 注册 TheHeader 组件   
  },
  setup() {
    const userStore = useUserStore();
    onMounted(() => {
      document.title = '怡养健康人力资源管理系统';
      // 先设置用户ID，然后再获取用户信息
      const storedDirectorId = localStorage.getItem('director_id');
      const storedDepartmentId = localStorage.getItem('department_id');
      
      if (storedDirectorId && storedDepartmentId) {
        userStore.updateUserIdAndDepartmentId(storedDirectorId, storedDepartmentId);
      }
      
      console.log('onMounted - 设置用户ID:', {
        director_id: userStore.director_id,
        department_id: userStore.department_id,
        storedDirectorId,
        storedDepartmentId
      });
      
      fetchData();
      fetchUserInfo();
    });    
    const datas = ref([]);
    const activeKey = ref(0); // Control the active sidebar item
    const route = useRoute();
    const fetchData = async () => {
      try {
        api.get('/assess/orders/', {
          params: {
            department_id: userStore.department_id,
            user_id: userStore.director_id
          }
        }).then((res) => {
          //console.log(res.data.data);          // 处理响应数据
          //console.log(userStore.director_id);
          datas.value = res.data.data; // 将数据赋值给 datas
          //赋值给datas 
        });

      } catch (error) {
        // 处理错误
        console.error('Error fetching data:', error);
      }
    };

    // 获取用户信息（包括多科室状态）
    const fetchUserInfo = async () => {
      try {
        console.log('fetchUserInfo - 请求参数:', {
          director_id: userStore.director_id,
          from_localStorage: localStorage.getItem('director_id')
        });
        
        const res = await api.get('/director/info', {
          params: {
            director_id: userStore.director_id
          }
        });
        
        const userInfo = res.data.data;
        console.log('用户信息接口返回数据:', res.data);
        console.log('用户信息对象:', userInfo);
        
        // 尝试从不同可能的数据结构中获取multi_status和multi_type
        let multiStatusVal, multiTypeVal;
        
        // 如果userInfo是director对象
        if (userInfo.director && (userInfo.director.multi_status !== undefined || userInfo.director.multi_type !== undefined)) {
          multiStatusVal = userInfo.director.multi_status;
          multiTypeVal = userInfo.director.multi_type;
          console.log('从director对象获取:', { multiStatusVal, multiTypeVal });
        }
        // 如果userInfo直接包含字段
        else if (userInfo.multi_status !== undefined || userInfo.multi_type !== undefined) {
          multiStatusVal = userInfo.multi_status;
          multiTypeVal = userInfo.multi_type;
          console.log('从userInfo对象获取:', { multiStatusVal, multiTypeVal });
        }
        // 默认值
        else {
          multiStatusVal = '0';
          multiTypeVal = 'assessment';
          console.log('使用默认值:', { multiStatusVal, multiTypeVal });
        }
        
        // 确保multi_status是字符串类型以便后续比较
        const multiStatusStr = String(multiStatusVal);
        
        // 更新用户存储中的多科室信息
        userStore.updateMultiInfo(multiStatusStr, multiTypeVal);
        
        console.log('更新后userStore.multi_status:', userStore.multi_status);
        console.log('更新后userStore.multi_status类型:', typeof userStore.multi_status);
        console.log('更新后userStore.multi_type:', userStore.multi_type);
        
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 如果接口不存在或失败，使用默认值
        userStore.updateMultiInfo('0', 'assessment');
      }
    };

    const sidebarItems = [
      { name: 'home', title: '本月考评', to: { name: 'home' } },
      { name: 'assesslist', title: '绩效汇总', to: { name: 'assesslist' } },
      { name: 'lastmonthfee', title: '科室费用', to: { name: 'lastmonthfee' } }, 
      { name: 'staffs', title: '科室职工', to: { name: 'staffs' } },
      { name: 'assesshistory', title: '考评记录', to: { name: 'assesshistory' } },
      { name: 'clocklist', title: '考勤记录', to: { name: 'clocklist' } },
      { name: 'standardspage', title: '考评标准', to: { name: 'standardspage' } },
      
      //{ name: 'applications', title: '请假申请', to: { name: 'applications' } },
    ];

    // Set the active sidebar item based on the current route
    activeKey.value = route.meta.sidebarKey || 0;

    // Watch for route changes and update the active sidebar item
    watch(route, (newRoute) => {
      activeKey.value = newRoute.meta.sidebarKey || 0;
    });

    return {
      activeKey,
      userStore,
      sidebarItems,
      datas, // 将数据作为响应式数据返回，以便在模板中使用
      fetchUserInfo
    };
  },
  methods: {
    goToAssess(id) {
      // 根据multi_status决定跳转到哪个考评页面
      // multi_status: 0=单科室, 1=多科室
      const userStore = useUserStore();
      
      // 将multi_status转换为字符串进行比较
      const multiStatusStr = String(userStore.multi_status);
      
      if (multiStatusStr === '1') {
        // 跳转到多科室考评页面
        this.$router.push({ name: 'multiassess', params: { id: id } });
      } else {
        // 跳转到单科室考评页面
        this.$router.push({ name: 'detail', params: { id: id } });
      }
    }
  }
};
</script>

<style>
  /* 业务相关样式 - 布局由全局CSS处理 */

  /* 业务相关样式 - 侧边栏样式已由全局CSS处理 */
  .content-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.content-item {
  width: calc(33.33% - 20px); /* Adjust width based on your layout */
}

.title-and-status {
  display: flex;
  justify-content: space-between;
  margin-bottom:11px;
}

.title {
  font-weight: bold;
  font-size: 18px;
}

.time p {
  margin-bottom: 10px;
}

hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}
.right-button {
  float: right; /* 使按钮浮动到右侧 */
}
</style>